import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'special',
	pure: false
})
export class SpecialPipe implements PipeTransform {

  transform(data: any, specialist: any): any {
		if (specialist == undefined ) {
			return data;
		} 
		else{
			 var out2=[];
			   for(var d in data){
					 for (var s in specialist){
						if(data[d].id==specialist[s].serviceprovider_id){
							out2.push(data[d]);
					   }
            }
		}
			return out2;
		}
	}
}
